export const churchMobileNavStyles = {
  dock: {
    alignItems: "stretch",
    backdropFilter: "blur(12px) saturate(1.1)",
    WebkitBackdropFilter: "blur(12px) saturate(1.1)",
    background: "rgba(255,255,255,0.96)",
    border: "1px solid rgba(15,23,42,0.08)",
    borderBottom: 0,
    borderRadius: "18px 18px 0 0",
    bottom: 0,
    boxShadow: "0 18px 42px rgba(15,23,42,0.18)",
    boxSizing: "border-box",
    display: "grid",
    gap: 4,
    height: "calc(66px + env(safe-area-inset-bottom))",
    left: 0,
    maxWidth: "none",
    minHeight: 0,
    overflow: "hidden",
    padding: "7px 10px max(7px, env(safe-area-inset-bottom))",
    position: "fixed",
    right: 0,
    top: "auto",
    width: "100%",
    zIndex: 160,
  },
  item: {
    background: "transparent",
    border: "1px solid transparent",
    borderRadius: 14,
    boxShadow: "none",
    color: "#64748b",
    flexDirection: "column",
    fontSize: 10,
    fontWeight: 750,
    gap: 4,
    height: 52,
    justifyContent: "center",
    letterSpacing: 0,
    minHeight: 52,
    minWidth: 0,
    outline: "none",
    overflow: "hidden",
    padding: "5px 2px",
    textAlign: "center",
    WebkitTapHighlightColor: "transparent",
  },
  activeItem: {
    background: "rgba(var(--color-primary-rgb),0.11)",
    borderColor: "rgba(var(--color-primary-rgb),0.14)",
    boxShadow: "inset 0 0 0 1px rgba(var(--color-primary-rgb),0.08)",
    color: "var(--color-primary-dark)",
    transform: "none",
  },
  label: {
    display: "block",
    lineHeight: 1,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};
